export default (state = null, action) => {
  switch (action.type) {
    case 'HOVERED_NODE/SET': {
      return action.payload;
    }
    default: {
      return state;
    }
  }
};
